import { atom } from "recoil";

export const playerHidePaywayEditModalStore = atom({
	key: "playerHidePaywayEditModalStore",
	default: {
		show: false,
		loaded: false,
		uid: false,
		group: "",
		date: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
